var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNurseIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18.741,
    height: 24.049,
    viewBox: "0 0 18.741 24.049",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a080f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.552,
    stopColor: "#7997f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a381f7"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "nurse-svgrepo-com_1_",
    "data-name": "nurse-svgrepo-com (1)",
    transform: "translate(-43.313)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3471",
    "data-name": "Path 3471",
    d: "M65.228,246.493v4.622H80.957v-4.622a3.67,3.67,0,0,0-2.715-3.734,26.138,26.138,0,0,0-10.3,0A3.662,3.662,0,0,0,65.228,246.493Z",
    transform: "translate(-20.403 -228.565)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3472",
    "data-name": "Path 3472",
    d: "M87.014,270.6v-3.119a2.364,2.364,0,0,1,1.584-2.249c1.546-.593,7.956-.571,9.55,0a2.35,2.35,0,0,1,1.584,2.249V270.6Z",
    transform: "translate(-40.685 -249.561)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_35813",
    "data-name": "Group 35813",
    transform: "translate(43.313 12.168)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3473",
    "data-name": "Path 3473",
    d: "M58.172,220.851a28.419,28.419,0,0,0-10.981,0,5.145,5.145,0,0,0-3.878,5.216v5.376a.715.715,0,0,0,.669.754h17.4a.714.714,0,0,0,.669-.754v-5.367A5.155,5.155,0,0,0,58.172,220.851Zm2.543,9.847H44.656v-4.622a3.681,3.681,0,0,1,2.773-3.734,27.262,27.262,0,0,1,10.517,0,3.685,3.685,0,0,1,2.773,3.734l0,4.622Z",
    transform: "translate(-43.313 -220.316)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3474",
    "data-name": "Path 3474",
    d: "M220.217,271.412H219.2v-1.017a.754.754,0,1,0-1.508,0v1.017h-1.017a.754.754,0,1,0,0,1.508h1.017v1.017a.754.754,0,1,0,1.508,0V272.92h1.017a.754.754,0,1,0,0-1.508Z",
    transform: "translate(-205.764 -266.237)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3475",
    "data-name": "Path 3475",
    d: "M135.968,21.786c-2.124,0-3.913,1.767-4.39,4.158a.026.026,0,0,1-.022.009c2.735-.6,3.221-1.231,3.293-1.365a.73.73,0,0,1,1.388.147c.085.165.79,1.281,4.225,2.03C140.283,23.99,138.338,21.786,135.968,21.786Z",
    transform: "translate(-83.334 -20.282)",
    fill: "#8484f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3476",
    "data-name": "Path 3476",
    d: "M139.181,86.984c-2.873-.593-4.283-1.477-4.966-2.168a10.711,10.711,0,0,1-3.953,1.392c.138,2.842,2.1,5.1,4.5,5.1C136.914,91.308,138.752,89.452,139.181,86.984Z",
    transform: "translate(-82.113 -79.826)",
    fill: "#efeefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3477",
    "data-name": "Path 3477",
    d: "M113.24,0c-2.584,0-4.7,2.9-4.824,6.585,0,.112,0,.223,0,.335,0,3.819,2.168,6.924,4.831,6.924,2.509,0,4.623-2.806,4.817-6.389,0-.022.018-.379.018-.54C118.071,3.105,115.906,0,113.24,0Zm-3.616,7.241A7.635,7.635,0,0,0,112.8,5.849a7.156,7.156,0,0,0,3.989,2.168c-.344,2.476-1.821,4.323-3.548,4.323C111.315,12.345,109.734,10.083,109.623,7.241Zm3.838-2.771c-.129-.727-.853-.79-1.115-.147-.057.134-.444.763-2.645,1.365a.019.019,0,0,1,.018-.009c.376-2.4,1.817-4.158,3.527-4.158,1.9,0,3.466,2.2,3.613,4.992C114.1,5.742,113.53,4.627,113.462,4.471Z",
    transform: "translate(-60.606)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNurseIcon);
export default __webpack_public_path__ + "static/media/nurse-icon.29e9a232df1a474e4f5eefe59a2fda04.svg";
export { ForwardRef as ReactComponent };